module.exports = __webpack_public_path__ + "img/template3-fs8.58b7ac40.png";